export default __webpack_public_path__ + "static/media/personBigIcon.e8a72632.svg";